var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#171796",
    d: "M0 0h60v45H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v30H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h60v15H0V0Zm30 34.1c4.8 0 8.7-3.9 8.7-8.7V15H21.3v10.4c0 4.8 3.9 8.7 8.7 8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 34a8.6 8.6 0 0 0 8.6-8.6V15.2H21.4v10.2A8.6 8.6 0 0 0 30 34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M25 15.5h-3.3V19h3.4v-3.6Zm0 7.2h3.4v-3.6H25v3.6Zm-3.3 2.7.1 1h3.3v-3.7h-3.4v2.7Zm10-2.7h-3.3v3.7h3.3v-3.7Zm0 7.3H35v-3.6h-3.3V30Zm3.3 2c.7-.6 1.3-1.2 1.8-2H35v2Zm-10-2h3.4v-3.6H25V30Zm-1.8 0c.5.8 1.1 1.4 1.8 2v-2h-1.8Zm7.4 3.6 1-.1V30h-3.3v3.5a8.2 8.2 0 0 0 2.3.1Zm7.6-7.2v-3.7H35v3.7h3.2Zm-6.5-3.7H35v-3.6h-3.3v3.6Zm0-7.2h-3.3V19h3.3v-3.6Zm6.6 3.6v-3.6H35V19h3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m38.4 14.9 2-4.7L39 7.7l-2.6 1-1.8-2L32.1 8 30 6.2 27.9 8l-2.4-1.4-1.8 2-2.6-.9-1.6 2.6 2 4.6a20.4 20.4 0 0 1 17 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0093DD",
    d: "m23.7 8.9-2.5-1-1.5 2.4.6 1.2 1.4 3.2c1-.5 2-.9 3.2-1.2L23.7 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.6 11.2.1.6a1.3 1.3 0 0 1-2.5.2 1.3 1.3 0 0 0 2.4-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.6 11.2a1.2 1.2 0 0 1-2.4.8 1.3 1.3 0 0 0 1.3 1c.7 0 1.2-.5 1.2-1.2l-.1-.6Zm0 0a1.3 1.3 0 0 1-1.3 1.5 1.3 1.3 0 0 1-1-.6 1.2 1.2 0 0 0 2.4-.3l-.1-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m21.3 10.7.1-.5-.3-.3.4-.1.1-.5.4.3.4-.1v.4l.3.3-.5.2v.4l-.4-.3-.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7DB17",
    d: "m21.9 10 .3.4.4-.2-.7-.1Zm0 0 .7.2-.3-.3-.4.2Zm-.8 0h.8l-.4-.2-.4.1Zm.8 0H21l.3.2.5-.1Zm0 0 .5-.5-.4.1-.1.5Zm-.5.7.5-.6-.4.1-.1.5Zm.5-.6-.5.6.4-.2v-.4Zm.5-.6-.5.6.4-.2v-.4Zm-.5.6-.3-.8v.5l.3.3Zm.2.7-.2-.7-.1.4.3.3Zm-.2-.7.2.7.1-.4-.3-.3Zm-.3-.8.3.8v-.5l-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171796",
    d: "m27.9 8.2-2.4-1.4L23.7 9l1.2 4.6 3.4-.5-.4-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m24.6 12.4 3.6-.6-.1-1.2a23 23 0 0 0-3.8.6l.3 1.2ZM24 10c1.3-.4 2.7-.6 4-.7l-.1-1.2c-1.4.1-2.8.3-4.2.7L24 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0093DD",
    d: "m32.1 8.2-2-1.7-2.2 1.7.4 4.8a20.8 20.8 0 0 1 3.4 0l.4-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m30 10.4-.1.1v.1h-.5v-.1s-.1 0 0 0v.3h.1v.1h-.2l.1.3a6.1 6.1 0 0 0-.2 0l.2.2v.2h-.1l.2.1v.3h.3v.2l.1-.1v.1h.1l.1-.1.1.1V12h.3v-.4h.2v-.1l-.1-.2.2-.1h-.2l.1-.4h-.2v-.1l.2-.3h-.2v.1h-.4l-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7DB17",
    d: "M30.6 10.7Zm-1.1 0Zm1 .2Zm-1 0Zm1-.1Zm-1 0a5.2 5.2 0 0 1 1 0v-.1l.2-.2h-.1l-.1.1-.2.1h-.1v-.1l-.2-.2-.1.1v.1h-.1v.1s-.1-.1-.2 0l-.1-.1h-.2.2v.1Zm1 .2H30a5.3 5.3 0 0 0-.1 0 3.3 3.3 0 0 0-.2 0 3.6 3.6 0 0 0-.1 0h-.3v.1-.1l.1.1h-.1V11v.2l.1.1h-.2a.3.3 0 0 0 .1 0h-.1l.2.1h.1-.1l-.1.2.1-.1h-.1v.2h.2-.1v.1l.1-.1-.1.1h.1-.1.2l-.1.2v-.1h.1v.1h-.1.2v-.1.4a.7.7 0 0 0 0-.2.4.4 0 0 1 0 .1.2.2 0 0 0 0-.1s.1 0 0 0h.1v.1h.1V12v.2l.1-.1V12v.1a.7.7 0 0 1 0-.1l.1.1v-.2.1h.2-.1.1v-.1h-.1.1v.1-.1h.2l-.1-.1h-.1.1v-.1.1-.1h-.1.5-.1.1v-.1h-.1c-.1-.1 0-.1 0-.1l.2-.2h-.2a.3.3 0 0 0 .1 0h-.2l.1-.1.1-.3v.1l-.1.1V11v.1-.1h.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7DB17",
    d: "M30.5 11a3.6 3.6 0 0 0-1 0 4.6 4.6 0 0 1 1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7DB17",
    fillRule: "evenodd",
    d: "M29.6 11a4.4 4.4 0 0 1 .9 0v-.1a4.2 4.2 0 0 0-1 0Zm.6-.2Zm0 0Zm-.2 0Zm0 0Zm-.2 0Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30 10.7v-.2.1Zm0 0v-.1Zm.2 1-.1.1h.1Zm0 0h-.1.1Zm-.4 0h.1-.1Zm0 0 .1.1Zm0 .2h.1v-.4a.3.3 0 0 0 .2 0v.2h-.2Zm.1 0h.1Zm.2-.7h.2-.2Zm-.2 0h-.1.2Zm0 .2Zm0-.3h.1v.2a.6.6 0 0 0-.1 0h-.1a.5.5 0 0 1-.1-.1h.2s0 .1 0 0h.1V11Zm0 .2h-.1a.4.4 0 0 1 .1 0Zm.2-.2v.1c0 .1 0 0 0 0h.1a.5.5 0 0 0 .2 0h-.1v.1H30V11Zm.2.1-.2.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M30.2 11.2v.1Zm0 0v.1Zm0 0v.1Zm-.4 0v.1Zm0 0v.1Zm0 0v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171796",
    d: "m36.3 8.9-1.8-2L32 8.1l-.4 4.8c1.2 0 2.3.3 3.4.5L36.3 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32.6 9.2h.4l.2-.1h.9l.2.2h.4s.1 0 0 0c-.2.2-.5 0-.7 0l.2.2.3.2h.5v.1h-.2a1 1 0 0 1-.5 0l-.3-.3-.3-.1h-.3.3v.1a.2.2 0 0 1-.2.1h-.2v.4h.2v.2h.1v.1h.3l.2.1h.6c0 .1 0 .1.1 0a.3.3 0 0 1 .3 0h.1l.1.1-.1.1-.1.2a.1.1 0 0 1-.2 0v.7h-.1v.2h-.2s0 .1 0 0c0 .2-.1.3-.2.3v.1h-.1v.2H34V12l.2-.1.1-.2h.1v-.2H34l-.1.1-.2.2v.1h-.1v.1h-.2v-.1l.2-.2.2-.2v-.1l-.2-.1h-.2l-.1.2v.2h-.1v.2l-.1.1h-.3v-.1h.1v-.1l.1-.2a.1.1 0 0 1 0-.2l.1-.2H33l-.1.2v.3h-.3c-.1 0-.1 0 0 0l.1-.2v-.2h.1v-.6c-.1 0-.2-.1-.1-.2v-.1l.1-.1v-.4h-.1v-.1c-.2 0-.2 0-.1-.1v-.1l.1-.1v-.2l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7DB17",
    d: "m34.2 11.4-.1.1H34l-.2.2v.2h-.2c0 .1-.1.1-.2 0h.1-.1l.2-.1.1-.1.1-.2v-.2h.4v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7DB17",
    d: "m32.7 10.6.1-.1v.2-.1h.1-.1v.2h.1v.2-.1.4l-.1.2-.2.2v.1h.2v-.4h.1v-.2h.1V11l.1-.1v.5a.1.1 0 0 0 0 .1v.1l-.1.2-.2.1h.1v.1h.2l-.1-.1.1-.1v-.1l.1-.2v-.1h.1v-.2.1h.1v-.1c0 .1.1 0 .1 0V11v.2h.1l.2-.2-.1.2h.1l.1-.1V11h.2-.1v.2h-.1.2v.2h.1v-.1.1h.1l.1.1v.1c0 .1 0 .2-.2.3v.1h-.4v.1h.1l.2.1V12s0-.1 0 0h.2l.1-.3v-.1h.2v-.1l.1-.1v-.2a1 1 0 0 0 .1 0V11l-.1-.1v-.1h.1v-.2h.1v-.1h.1v-.1h.2v-.1h-.5v.1h-.1v-.1h-.4l.1.1v-.2h-.1v.1a.4.4 0 0 0-.1 0v.1-.2H34v.2-.2h-.2v.1-.1h-.1v.1-.1l-.1-.1V10l-.2-.1v-.1h-.1v-.2H33h.2v-.1h.5-.1.1v-.1h-.3v-.1h-.1.4v-.2h-.2v.1-.1h-.2v.1H33h.1l.1-.1h.1-.2l-.2.1h-.1v.1l-.2.2v.2h.4l-.1.2h.1v-.1h.2-.1l-.1.2.1-.1v.1H33v.1l-.1.2h.1-.1l-.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7DB17",
    d: "M32.8 9.4h-.1v-.1c0-.1 0-.1.1 0h.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.2 11.4Zm.2.4Zm.1-.1Zm0 0h-.1Zm0-.2Zm.2 0v.1Zm0-.6v.2a.1.1 0 0 0 0-.2v.2-.1Zm-.1.1Zm0 .2v.1-.1Zm0 0v.1Zm.1 0v.2-.2Zm0-.1Zm0-.3Zm0-.2v.1Zm-.1 0v.4-.1.1-.4Zm.4-.1Zm0 0Zm-.2 0v.1Zm-.6 0v.1Zm0 0h.1Zm.3.2Zm0-.2h.1Zm-.4 0v.1Zm.2.2v.2l.1-.2v.2l-.1-.1v-.1Zm-.1 0v.2-.1Zm0 0v.1H34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34 10.7v.1a.2.2 0 0 0 0 .1l.1-.1-.1.1v-.2Zm.2.3v.2-.2Zm.1 0Zm.1 0v.1Zm.1.4Zm0-.1Zm-.2 0Zm0 0Zm-.2 0v.1Zm-.5.5Zm.1 0Zm.1 0Zm.1-.4Zm.1-1Zm0 0Zm-.2 0Zm.1.3Zm-.1-.2v.2-.1l.1-.1v.1-.1.2l-.1-.2Zm0 .5Zm-.1 0v.1Zm.1-.2v.2-.1Zm0 0v.1h-.1v-.1h.1Zm-.2 0v.2h-.1v-.1Zm-.3.2Zm-.1 0v.2-.2Zm0 .4Zm0 .1Zm-.1.2Zm-.1-.6Zm-.2.4Zm.5-.7v.2-.2Zm0-.1v.1h-.1v.2a.2.2 0 0 1 0-.2v-.1Zm-.3.3Zm0 0Zm.5-.9v.2-.1Zm-.1 0v.3-.2Zm-.3.1v.4-.1l-.1-.2v-.1Zm.3-.1v.2-.2Zm-.4 0v.2-.2Zm.2 0Zm0 0v.4l-.1-.1V10h.1Zm0-.1v.1-.1Zm.5.5v.1Zm0 .2v.2-.1Zm-.1-.1a.2.2 0 0 1 0 .2.2.2 0 0 0 0-.2Zm0 .2h-.1v.2-.1l-.1-.1v-.1.2h.1v-.1Zm-.3-.1v.1-.1Zm-.2 0Zm0-.1v.1-.1Zm0 .3s-.1-.1 0-.2v-.2.4Zm-.2-.1Zm.5-.3v.2-.2Zm.1-.1v.1-.1Zm0-.1h.1v.1-.1Zm-.1 0Zm-.4.2v.1l-.1.1v-.2Zm0-.1Zm.2 0Zm.1-.2v.4-.4Zm-.4-.7h.2-.2.2-.2Zm.1 0Zm.1.1h.1Zm.4-.1Zm-.2 0Zm0 0Zm-.3.1Zm0 0Zm0 0Zm0-.2Zm0 0Zm0 0h-.1Zm-.2 0v.1Zm0 .1Zm0 0v.1Zm0 .2Zm0 0Zm0-.5Zm.4.7Zm-.1.2v-.3.3Zm-.2-.1Zm0 0Zm.1-.2Zm0 0Zm2.2.6Zm-2.5 1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M34.6 9.3h.1l-.1.1Zm-.1 0v.1Zm-1-.3h.2v.1h.2v.1h.3v.1h.2v.1l-.4-.1-.2-.1h-.3V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M33.2 9h.3v.2h-.2V9Zm.7.5-.3-.2v-.1h.3v.1s-.1 0 0 0h.2v.1h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m34.1 9.6-.1-.1v-.1h.2v.2Zm.2.1h-.2.1v-.1h.3v.1h-.2Zm.2.1h-.1v-.1h.2v.1Zm.5 0h-.4.4ZM34 12v.1l.2.1V12h-.1Zm-1.3-.4h-.1v.1h.2-.1v-.1Zm.9.3c0 .1-.1.1-.2 0h.1-.1.2Zm-.7 0c-.1 0 0 0 0 0v.1h.2l-.1-.1Zm.3-2.5h.4v-.2h-.2v.1-.1h-.2v.1H33h.2Zm-.2 0v-.1h.1l.1-.1h.1-.2l-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0093DD",
    d: "m38.3 14.7 2-4.4-1.4-2.4-2.6 1-1.2 4.7c1.1.2 2.2.6 3.2 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.9 10.6c1.2.3 2.5.7 3.7 1.3l-.8 1.7c-1-.5-2.2-1-3.4-1.2l.5-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m39 13.3.4-1.1c-1.1-.6-2.4-1-3.6-1.3l-.3 1.2c1.2.3 2.3.7 3.5 1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.2 11.8h.2v-.1l-.1-.1h-.1l-.1-.1H36v-.2h.5v.2h.1l.5.3h.4c.3 0 .5 0 .7.2h.2l.2.1h.2l.2.2-.2.1h-.1l-.3-.2h-.2v.1l.1.1h.1v.4h.1l-.1.2h-.1v-.5l-.3-.2h-.7c-.1 0 0 0 0 0l.2-.1h-.1c-.1-.2-.2-.2-.3-.1h-.6V12h.4-.2l-.1-.1H36c-.1-.1-.1-.1 0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.6 12.2h-.4V12h.4v.1h.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M37.8 8.9v.5l-.3.3.5.1v.5l.4-.3.5.1-.1-.4.3-.3-.4-.2-.1-.5-.4.3-.4-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7DB17",
    d: "m37.6 9.7.3-.3.4.1-.7.2Zm.8-.2.3-.3.4.2-.7.1Zm.7-.1-.3.3-.4-.2.7-.1Zm-.8.1-.3.3-.4-.1.7-.2Zm-.5-.6.4.2.1.4-.5-.6Zm.5.6.5.2v.4l-.5-.6Zm.5.6-.4-.1v-.5l.4.6Zm-.5-.6-.4-.1v-.5l.4.6Zm.3-.7v.4l-.3.3.3-.7Zm-.3.7.1.5-.3.2.2-.7Zm-.2.7-.1-.4.3-.3-.2.7Zm.2-.7V9l.3-.3-.3.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/hr.9421537ef66798f8916bfb5e14d9e30b.svg";
export { ForwardRef as ReactComponent };